import { Directive, ElementRef, Input, OnInit, OnDestroy, NgZone } from '@angular/core';

@Directive({
  selector: '[appReveal]'
})
export class RevealDirective implements OnInit, OnDestroy {
  /** Optional delay in ms before applying the visible class (for stagger). */
  @Input('appReveal') delayMs: number | string = 0;

  private observer: IntersectionObserver | null = null;

  constructor(private host: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngOnInit(): void {
    const el = this.host.nativeElement;
    el.classList.add('reveal');

    if (typeof IntersectionObserver === 'undefined') {
      // Fallback: just show.
      this.markVisible();
      return;
    }

    this.zone.runOutsideAngular(() => {
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const delay = Number(this.delayMs) || 0;
            window.setTimeout(() => this.markVisible(), delay);
            this.observer?.unobserve(entry.target);
          }
        }
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      this.observer.observe(el);
    });
  }

  /** Public so callers / tests can force-reveal. */
  markVisible(): void {
    this.host.nativeElement.classList.add('is-visible');
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
